import { Component } from '@theme/component';

/**
 * Front / back over the first product image.
 *
 * The rear view is already in the document, stacked over the front and hidden,
 * so a flip is a visibility change rather than a fetch — no layout shift, no
 * blank frame. It is decoded on the first flip and stays decoded.
 */
class LeaGalleryView extends Component {
  requiredRefs = [];

  connectedCallback() {
    super.connectedCallback();
    // Nothing to attach to: the overlay is rendered inside the first tile.
  }


  showFront = () => this.#set(false);
  showBack = () => this.#set(true);

  /** One control, so pressing it means "show me the other one". */
  toggle = () => this.#set(!this.#showingBack());

  #showingBack() {
    const rear = this.querySelector('[data-lea-rear]');
    return rear instanceof HTMLElement ? !rear.hidden : false;
  }

  /** @param {boolean} back */
  #set(back) {
    const rear = this.querySelector('[data-lea-rear]');
    if (rear instanceof HTMLElement) rear.hidden = !back;

    const button = this.refs.toggle;
    if (button instanceof HTMLElement) {
      // The label is the destination, not the current state: on the front it
      // offers the back, on the back it offers the way home.
      button.textContent = back ? (button.dataset.labelFront ?? '') : (button.dataset.labelBack ?? '');
      button.setAttribute('aria-pressed', String(back));
    }

    this.refs.front?.setAttribute('aria-pressed', String(!back));
    this.refs.back?.setAttribute('aria-pressed', String(back));
  }
}

if (!customElements.get('lea-gallery-view')) {
  customElements.define('lea-gallery-view', LeaGalleryView);
}
